<sol-modal
    (dismissed)="cancel()"
    (close)="approve()"
    [title]="cvLocalizationService.getCachedText('CXOne_Dashboard', 'Delete_Subscription', 'Delete Subscription')">

    <!-- Body -->
    <sol-modal-body>
        <div class="body-row" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Delete_Confirmation'">Are you sure you want to delete subscription?</div>
        <div class="body-row" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Users_Message'">This action will affect all the users listed</div>
        <div class="body-row recipient-list">
            <div class="recipient-item" *ngFor="let email of recipientEmails">{{ email }}</div>
        </div>
    </sol-modal-body>
    <!-- Body End -->

    <!-- Footer -->
    <sol-modal-footer>
        <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="approve()" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Approve'">Approve</button>
    </sol-modal-footer>
    <!-- Footer End -->

</sol-modal>
